import { render, staticRenderFns } from "./IconTruck.vue?vue&type=template&id=bcb52310&"
import script from "./IconTruck.vue?vue&type=script&lang=ts&"
export * from "./IconTruck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports